.table {
    :global {
        .cell:nth-child(2) {
            justify-content: end;
            display: flex;
        }
    }
}